var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53.998,
    viewBox: "0 0 54 53.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M23.823,23.825a3.375,3.375,0,0,1,4.776,0L41.592,36.818a3.375,3.375,0,0,1-4.771,4.776L23.828,28.6a3.375,3.375,0,0,1,0-4.776Z",
    transform: "translate(11.418 11.417)",
    fill: "#74613c",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M21.937,40.5A18.562,18.562,0,1,0,3.375,21.937,18.562,18.562,0,0,0,21.937,40.5ZM43.874,21.937A21.937,21.937,0,1,1,21.937,0,21.937,21.937,0,0,1,43.874,21.937Z",
    fill: "#74613c",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6506338351bd1233544c14a789fcd075.svg";
export { ForwardRef as ReactComponent };